import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useAdminGet } from './dsfApi';
import { DsfStatusBar } from './DsfStatusBar';
import { DsfDailyCard } from './DsfDailyCard';
import { DsfPlayersCard } from './DsfPlayersCard';
import { DsfRecordsCard } from './DsfRecordsCard';
import { DsfLiveCard } from './DsfLiveCard';
import { DsfSettingsCard } from './DsfSettingsCard';

export default function DeepSeaFurtuneAdminTab() {
    const [days, setDays] = useState(7);
    const [picked, setPicked] = useState(null);
    const [overview, reload, , setOverview] = useAdminGet(`/admin/dsf/overview?days=${days}`);
    const [live, reloadLive] = useAdminGet('/admin/dsf/live', 10000);
    return (
        <div className="space-y-4" data-testid="dsf-admin-tab">
            <div className="flex items-center gap-2">
                <h2 className="mr-auto text-lg font-black text-white">Deep Sea Furtune · Fish Table</h2>
                <Button size="sm" variant="ghost" className="text-white/70" onClick={() => { reload(); reloadLive(); }} data-testid="dsf-admin-refresh"><RefreshCw className="h-4 w-4" /></Button>
            </div>
            <DsfStatusBar settings={overview?.settings} live={live} />
            <DsfLiveCard live={live} />
            <div className="grid items-start gap-4 xl:grid-cols-2">
                <DsfDailyCard data={overview} days={days} setDays={setDays} />
                <DsfSettingsCard settings={overview?.settings} onSaved={(s) => setOverview((o) => ({ ...o, settings: s }))} />
            </div>
            <DsfPlayersCard players={overview?.players} picked={picked} onPick={setPicked} />
            <DsfRecordsCard userId={picked} clearUser={() => setPicked(null)} />
        </div>
    );
}
